import { useMemo } from 'react';
import { DefaultTheme } from '@mui/styles';
type ChartStylesReturnProps = {
  VictoryChart: {
    height: number;
    padding: number;
    domainPadding: number;
  };
  VictoryBar: {
    width: number;
  };
  VictoryAxis: {
    axis: {
      stroke: string;
    };
    ticks: {
      stroke: string;
    };
    tickLabels: {
      fill: string;
    };
  };
};
export const useChartStyles = (theme: DefaultTheme): ChartStylesReturnProps => {
  return useMemo(
    () => ({
      VictoryChart: {
        height: parseInt(theme.spacing(5)),
        padding: parseInt(theme.spacing(0.25)),
        domainPadding: 0
      },
      VictoryBar: {
        width: parseInt(theme.spacing(4))
      },
      VictoryAxis: {
        axis: { stroke: 'transparent' },
        ticks: { stroke: 'transparent' },
        tickLabels: { fill: 'transparent' }
      }
    }),
    [theme]
  );
};
